import type { SVGProps } from 'react';
const SvgQueuePlayNext = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="0.75em"
    height="0.75em"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#queue_play_next_svg__a)">
      <path
        fill="currentColor"
        d="M21 3H3c-1.11 0-2 .89-2 2v12a2 2 0 0 0 2 2h5v2h8v-2h2v-2H3V5h18v8h2V5a2 2 0 0 0-2-2Zm-8 7V7h-2v3H8v2h3v3h2v-3h3v-2h-3Zm11 8-4.5 4.5L18 21l3-3-3-3 1.5-1.5L24 18Z"
      />
    </g>
    <defs>
      <clipPath id="queue_play_next_svg__a">
        <path fill="currentColor" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgQueuePlayNext;
